export enum eAgendaTabs {
  EVENTS = 'EVENTS',
  CALENDAR = 'CALENDAR',
  TEAM = 'TEAM',
  CREATE_EVENT = 'CREATE_EVENT',
  TEMPLATES = 'TEMPLATES',
}

export enum eFieldTypes {
  STRING = 'String',
  NUMBER = 'Number',
  DATE_TIME = 'DateTime',
  USERS = 'Users',
  LINKS = 'Links',
}

export enum eUpdateType {
  CREATE = 'CREATE',
  DELETE = 'DELETE',
}

export enum eTemplateTypeColors {
  EVENT_TYPE_CALL = 'call',
  EVENT_TYPE_MEETING = 'meeting',
  EVENT_TYPE_TASK = 'task',
}

export enum eTemplateTypeNames {
  EVENT_TYPE_CALL = 'Llamada',
  EVENT_TYPE_MEETING = 'Reunión',
  EVENT_TYPE_TASK = 'Tarea',
}

export enum eEventState {
  CREATED = 'CREATED',
  PENDING = 'PENDING',
  SCHEDULED = 'SCHEDULED',
  PAST_DUE = 'PAST_DUE',
  FINISHED = 'FINISHED',
  DELETED = 'DELETED',
}
